import deepmerge from 'deepmerge'
import backendText from 'config/text-dump.json'
import frontendText from 'config/text.json'
const textJson = deepmerge(backendText, frontendText)
export default (api) => {
  api.text = {
    public: {
      textFromJson: () => {
        return new Promise(async resolve => {
          const version = window.rootComponent.application.text.version
          resolve({
            version,
            data: textJson,
          })
        })
      },
      all: (latestVersion = 1, textCache = true) => {
        let cache = process.env.NODE_ENV == 'production'
          ? { key: 'text', latestVersion }
          : null

        cache = { key: 'text', latestVersion, cache: textCache, }
        return api.request({
          url: `/api/text`,
          type: 'get',
          cache,
        })
      },
      allWithoutCache: () => {
        return api.request({
          url: `/api/text`,
          type: 'get',
        })
      },
    },
    admin: {
      read: (type) => api.request({
        url: `/api/admin/text/read/${type}`,
        type: 'get',
      }),
      types: () => api.request({
        url: `/api/admin/text/types`,
        type: 'get',
      }),
      update: (type, params) => api.request({
        url: `/api/admin/text/update/${type}`,
        type: 'put',
        params,
      }),
    }
  }
}